/*
  Zepto Variant Sync (2026-07)
  ------------------------------------------------------------------
  Synchronisiert die im Zepto-Personalizer gewaehlte Flaschenfarbe mit der
  echten Shopify-Farbvariante, blendet bei aktiver Personalisierung den
  Shopify-Farbpicker aus und stellt beim Entfernen der Personalisierung den
  urspruenglichen Shopify-Zustand vollstaendig wieder her.

  Mapping-Regel (final, autoritativ):
    - Quelle: das Zepto-Feld "Tag" (data-tag) je Bild-Swatch.
    - Matching: EXAKT gegen den Shopify-Variantenwert (option1),
      Normalisierung nur: trim + Gross-/Kleinschreibung tolerant.
    - KEINE Farbfamilien, KEIN Bild-Sampling, KEIN data-val/Label als Quelle.
    - Die Farbgruppe wird generisch ueber ihre TAGS erkannt: es ist die
      Bild-Swatch-Gruppe, deren data-tag-Werte eine VOLLSTAENDIGE, eindeutige
      Bijektion zu den Shopify-Farbvarianten des Produkts bilden. NICHT nur
      ueber die Anzahl der Swatches.
    - Fehlt/uneindeutig/kein exakter Treffer -> Sync bleibt AUS,
      Shopify-Picker bleibt sichtbar, es wird NIE eine falsche Variante gesetzt.

  Zweite Funktion (Cart-Hider):
    Blendet im kundensichtbaren Warenkorb (Notification, Drawer, Cart-Page) die
    REDUNDANTE technische Zepto-Farbproperty aus (z. B. "Flasche: jj1711-P").
    Erkennung generisch: der Sync merkt sich pro erkannter Farbgruppe die Paare
    (Gruppen-Label || data-val) in localStorage; nur exakt diese Property-Zeilen
    werden ausgeblendet. Die Property wird NICHT geloescht (Zepto/Bestellung/
    Preview bleiben vollstaendig erhalten) - nur visuell verborgen.

  Generisch: kein Produkt-Handle, keine Product-ID, kein jj1711/JJ1710, kein
  Gruppenname hartkodiert.

  Beruehrt ausschliesslich Variant-/id-Felder, Picker-Sichtbarkeit und die
  Sichtbarkeit der einen redundanten Farbproperty. Aendert NICHT den
  bestehenden Zepto-Preview-Fix.
*/
(function () {
  'use strict';

  var ACTIVE_CLASS = 'lw-zvs-active';
  var HIDE_KEY = 'lw_zvs_hide_pairs';

  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function q(s, r) { return (r || document).querySelector(s); }
  function vis(el) { return !!(el && el.offsetParent !== null); }
  function norm(s) { return (s == null ? '' : ('' + s)).trim().toLowerCase(); }

  // ===================================================================
  //  Persistenz der Hide-Paare (Gruppen-Label || data-val)
  // ===================================================================
  function loadPairs() { try { return JSON.parse(localStorage.getItem(HIDE_KEY) || '[]'); } catch (e) { return []; } }
  function addPairs(pairs) {
    if (!pairs || !pairs.length) return;
    try {
      var set = {}; loadPairs().concat(pairs).forEach(function (p) { set[p] = 1; });
      localStorage.setItem(HIDE_KEY, JSON.stringify(Object.keys(set)));
    } catch (e) {}
  }

  // ===================================================================
  //  FEATURE 1 — Farb-/Varianten-Sync (nur Produktseite)
  // ===================================================================
  var S = {
    variantsByValue: {}, // norm(option1) -> { id, value }
    radiosByValue: {},   // norm(value)   -> radioEl
    colorGroup: null,    // erkanntes Farbgruppen-Element
    swatchMap: {},       // data-val -> { id, value }
    ready: false,
    resolving: false,
    retryTimer: null,
    retryAttempts: 0,
    active: false,
    session: null        // { origVariantId, origRadioValue }
  };

  function loadVariants() {
    var path = location.pathname.replace(/\/$/, '');
    return fetch(path + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (!p || !p.variants) return false;
        var by = {};
        p.variants.forEach(function (v) {
          var k = norm(v.option1);
          if (k && !by[k]) by[k] = { id: String(v.id), value: v.option1 };
        });
        S.variantsByValue = by;
        return Object.keys(by).length > 0;
      })
      .catch(function () { return false; });
  }

  function readRadios() {
    S.radiosByValue = {};
    qa('variant-selects input[type="radio"]').forEach(function (el) {
      S.radiosByValue[norm(el.value)] = el;
    });
  }

  function swatchValue(sw) { return sw.getAttribute('data-val') || sw.getAttribute('data-value'); }
  function groupLabelText(g) {
    var l = q('.pplrlabel, .pplr-title, .pplr-label, label', g);
    return l ? l.textContent.trim() : '';
  }

  // Baut aus den Swatches einer Gruppe die exakte Tag->Variante-Zuordnung.
  // Nur gueltig, wenn ALLE Swatches ein Tag haben, das EXAKT einer Variante
  // entspricht, jede Variante hoechstens einmal, UND alle Varianten abgedeckt
  // sind (vollstaendige Bijektion). Sonst null.
  function buildMap(sws) {
    if (!sws.length) return null;
    var variantCount = Object.keys(S.variantsByValue).length;
    if (!variantCount) return null;
    var map = {}, used = {}, matched = 0;
    for (var i = 0; i < sws.length; i++) {
      var val = swatchValue(sws[i]);
      if (!val) return null;
      var tag = (sws[i].getAttribute('data-tag') || '').trim();
      if (!tag) return null;
      var v = S.variantsByValue[norm(tag)];
      if (!v) return null;
      if (used[v.id]) return null;
      used[v.id] = 1;
      map[val] = { id: v.id, value: v.value };
      matched++;
    }
    if (matched !== variantCount) return null; // nicht alle Farbvarianten abgedeckt
    return map;
  }

  // Generische Gruppenerkennung: die Gruppe, deren Tags zu den Varianten passen.
  function findColorGroup() {
    var groups = qa('.pplr-wrapper');
    for (var i = 0; i < groups.length; i++) {
      var sws = qa('.pplr-swatch-element.pplrimage', groups[i]);
      var m = buildMap(sws);
      if (m) return { group: groups[i], map: m };
    }
    return null;
  }

  function setIdInputs(id) {
    qa('input[name="id"]').forEach(function (i) { if (i.value !== String(id)) i.value = String(id); });
  }
  function selectRadio(value, fireChange) {
    var el = S.radiosByValue[norm(value)];
    if (!el) return;
    if (!el.checked) el.checked = true;
    if (fireChange) el.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function selectedMapping() {
    if (!S.colorGroup || !document.contains(S.colorGroup)) return null;
    var sw = q('.pplr-swatch-element.selected', S.colorGroup);
    if (!sw) return null;
    return S.swatchMap[swatchValue(sw)] || null;
  }
  function syncFromSelection() {
    if (!S.ready || !S.active) return;
    var m = selectedMapping();
    if (!m) { updateSelectedColorLabel(); return; }
    setIdInputs(m.id);
    selectRadio(m.value, false); // still: Media/Preview nicht stoeren
    updateSelectedColorLabel();
  }

  // --- Anzeige: "<Gruppenlabel>: <aktueller Tag>" (rein visuell) ----------
  // Autoritative Quelle: data-tag des aktuell gewaehlten Swatches der bereits
  // erkannten Farbgruppe. Der originale Label-Text und der Property-Key
  // (input name="properties[<Label>]") bleiben UNVERAENDERT.
  function selectedSwatchTag() {
    if (!S.colorGroup || !document.contains(S.colorGroup)) return null;
    var sw = q('.pplr-swatch-element.selected', S.colorGroup);
    if (!sw) return null;
    var tag = (sw.getAttribute('data-tag') || '').trim();
    return tag || null;
  }
  function updateSelectedColorLabel() {
    if (!S.ready || !S.colorGroup || !document.contains(S.colorGroup)) return;
    var labelEl = q('.pplrlabel, .pplr-title, .pplr-label, label', S.colorGroup);
    if (!labelEl) return;
    // Duplikate vermeiden: hoechstens EIN Display-Span, im aktuellen Label.
    qa('.lw-zvs-selected-color', S.colorGroup).forEach(function (sp) {
      if (sp.parentNode && sp.parentNode !== labelEl) sp.parentNode.removeChild(sp);
    });
    var tag = selectedSwatchTag();
    var span = q('.lw-zvs-selected-color', labelEl);
    if (!tag) { if (span && span.parentNode) span.parentNode.removeChild(span); return; }
    if (!span) {
      span = document.createElement('span');
      span.className = 'lw-zvs-selected-color';
      labelEl.appendChild(span);
    }
    var desired = ': ' + tag;
    if (span.textContent !== desired) span.textContent = desired;
  }
  function clearSelectedColorLabel() {
    qa('.lw-zvs-selected-color').forEach(function (sp) { if (sp.parentNode) sp.parentNode.removeChild(sp); });
  }

  function pickerHost() { return q('.product') || document.body; }
  function hidePicker() { pickerHost().classList.add(ACTIVE_CLASS); }
  function showPicker() { pickerHost().classList.remove(ACTIVE_CLASS); }

  function captureSession() {
    var idInput = q('input[name="id"]');
    var checked = q('variant-selects input[type="radio"]:checked');
    S.session = {
      origVariantId: idInput ? idInput.value : null,
      origRadioValue: checked ? checked.value : null
    };
  }
  function onDeactivate() {
    clearSelectedColorLabel();
    if (S.session) {
      if (S.session.origVariantId) setIdInputs(S.session.origVariantId);
      if (S.session.origRadioValue) selectRadio(S.session.origRadioValue, true);
    }
    showPicker();
    S.session = null;
  }

  function scheduleRetry() {
    if (S.retryTimer || S.retryAttempts > 12) return;
    S.retryTimer = setTimeout(function () {
      S.retryTimer = null; S.retryAttempts++; tryResolve();
    }, 500);
  }
  function tryResolve() {
    if (!S.active || S.ready || S.resolving) return;
    S.resolving = true;
    var found = null;
    try { found = findColorGroup(); } catch (e) { found = null; }
    S.resolving = false;
    if (found) {
      S.colorGroup = found.group;
      S.swatchMap = found.map;
      S.ready = true;
      // Hide-Paare (Label || data-val) fuer den Cart-Hider merken
      var label = groupLabelText(found.group);
      if (label) addPairs(Object.keys(found.map).map(function (val) { return norm(label) + '||' + norm(val); }));
      hidePicker();
      syncFromSelection();
    } else {
      S.ready = false;
      if (S.active) scheduleRetry();
    }
  }

  function updateActive() {
    var now = qa('.pplr-swatch-element').some(vis);
    if (now !== S.active) {
      S.active = now;
      if (now) { S.retryAttempts = 0; captureSession(); tryResolve(); }
      else { S.ready = false; S.retryAttempts = 0; if (S.retryTimer) { clearTimeout(S.retryTimer); S.retryTimer = null; } onDeactivate(); }
    } else if (now && !S.ready) {
      tryResolve();
    } else if (now && S.ready) {
      updateSelectedColorLabel(); // nach Zepto-Re-Render Span/Farbe sicherstellen
    }
  }

  function onSwatchInteraction(e) {
    if (!S.active || !S.ready || !S.colorGroup) return;
    var sw = (e.target && e.target.closest) ? e.target.closest('.pplr-swatch-element') : null;
    if (!sw || !S.colorGroup.contains(sw)) return;
    setTimeout(syncFromSelection, 60);
    setTimeout(syncFromSelection, 220);
  }

  function preAtcGuard(e) {
    if (!S.active || !S.ready) return;
    var m = selectedMapping();
    if (m) { setIdInputs(m.id); return; }
    e.preventDefault();
    e.stopPropagation();
    try { window.alert('Bitte die Flaschenfarbe erneut auswaehlen, bevor du in den Warenkorb legst.'); } catch (_) {}
  }

  function initSync() {
    if (!q('variant-selects')) return; // keine Shopify-Farbvariante -> nichts zu tun
    readRadios();
    loadVariants().then(function (ok) {
      if (!ok) return;
      var scheduled = false;
      var obs = new MutationObserver(function () {
        if (scheduled) return; scheduled = true;
        setTimeout(function () { scheduled = false; updateActive(); }, 50);
      });
      obs.observe(q('.product') || document.body, { childList: true, subtree: true });
      var polls = 0;
      var poll = setInterval(function () { updateActive(); if (++polls > 40) clearInterval(poll); }, 500);
      document.addEventListener('click', onSwatchInteraction, true);
      document.addEventListener('change', onSwatchInteraction, true);
      document.addEventListener('submit', preAtcGuard, true);
      updateActive();
    });
  }

  // ===================================================================
  //  FEATURE 2 — Cart-Hider (alle Seiten mit Warenkorb-Darstellung)
  // ===================================================================
  function hideCartColorProps(root) {
    var pairs = loadPairs();
    if (!pairs.length) return;
    var set = {}; pairs.forEach(function (p) { set[p] = 1; });
    // Dawn rendert oeffentliche line-item-Properties als .product-option (dt/dd)
    qa('.product-option', root || document).forEach(function (row) {
      if (row.getAttribute('data-lw-zvs-checked') === '1' && row.style.display === 'none') return;
      var dt = q('dt', row), dd = q('dd', row);
      if (!dt || !dd) return;
      var key = norm(dt.textContent.replace(/:\s*$/, ''));
      var val = norm(dd.textContent);
      row.setAttribute('data-lw-zvs-checked', '1');
      if (set[key + '||' + val]) row.style.display = 'none';
    });
  }

  function initCartHider() {
    var run = function () { try { hideCartColorProps(); } catch (e) {} };
    run();
    // Warenkorb-Container (Notification, Drawer, Cart-Page) beobachten
    var roots = qa('cart-notification, cart-drawer, #cart, #main-cart-items, .cart-notification, .drawer__inner, .js-contents');
    var targets = roots.length ? roots : [document.body];
    var scheduled = false;
    var obs = new MutationObserver(function () {
      if (scheduled) return; scheduled = true;
      setTimeout(function () { scheduled = false; run(); }, 60);
    });
    targets.forEach(function (t) { obs.observe(t, { childList: true, subtree: true }); });
  }

  // ===================================================================
  function init() { initSync(); initCartHider(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
